"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getUserGroupChallengeStatsIsLoadingSelector = exports.getUserGroupChallengeStatsDataSelector = exports.getUserRegistrationLoadingSelector = exports.getUserRegistrationErrorSelector = exports.getUserRegistrationSuccessSelector = exports.getChallengeStatsIsLoadingSelector = exports.getChallengeStatsDataSelector = exports.getUserChallengeActionsLoadingSelector = exports.getUserChallengeActionsDataSelector = exports.getUserChallengeActivitiesLoadingSelector = exports.getUserChallengeActivitiesDataSelector = exports.getUserGroupChallengeIsLoadingSelector = exports.getUserGroupChallengeDataSelector = exports.isSuccessChallengeSelector = exports.getUserChallengeHasUpdatedSelector = exports.getUserChallengeErrorSelector = exports.getUserChallengeIsLoadingSelector = exports.getUserChallengeDataSelector = exports.getChallengeGroupChallengeDataSelector = exports.getChallengeDataDisplaySelector = exports.getChallengeTypeSelector = exports.getChallengeErrorSelector = exports.getChallengeIsLoadingSelector = exports.getChallengeDataSelector = void 0;

var _reselect = require("reselect");

var _get = _interopRequireDefault(require("lodash/get"));

var challengeRootSelector = function challengeRootSelector(state) {
  return state.challenge;
};

var getChallengeSelector = (0, _reselect.createSelector)([challengeRootSelector], function (challengeRoot) {
  return (0, _get["default"])(challengeRoot, 'currentChallenge');
});
var getChallengeDataSelector = (0, _reselect.createSelector)([getChallengeSelector], function (challenge) {
  return (0, _get["default"])(challenge, 'data');
});
exports.getChallengeDataSelector = getChallengeDataSelector;
var getChallengeIsLoadingSelector = (0, _reselect.createSelector)([getChallengeSelector], function (challenge) {
  return (0, _get["default"])(challenge, 'isLoading');
});
exports.getChallengeIsLoadingSelector = getChallengeIsLoadingSelector;
var getChallengeErrorSelector = (0, _reselect.createSelector)([getChallengeSelector], function (challenge) {
  return (0, _get["default"])(challenge, 'error');
});
exports.getChallengeErrorSelector = getChallengeErrorSelector;
var getChallengeTypeSelector = (0, _reselect.createSelector)(getChallengeDataSelector, function (data) {
  return (0, _get["default"])(data, 'challengeType', 'unknown');
});
exports.getChallengeTypeSelector = getChallengeTypeSelector;
var getChallengeDataDisplaySelector = (0, _reselect.createSelector)([getChallengeDataSelector], function (data) {
  return (0, _get["default"])(data, 'display');
});
exports.getChallengeDataDisplaySelector = getChallengeDataDisplaySelector;
var getChallengeGroupChallengeDataSelector = (0, _reselect.createSelector)([getChallengeDataSelector], function (data) {
  return (0, _get["default"])(data, 'groupChallenge');
});
exports.getChallengeGroupChallengeDataSelector = getChallengeGroupChallengeDataSelector;
var getUserChallengeSelector = (0, _reselect.createSelector)(challengeRootSelector, function (challengeRoot) {
  return (0, _get["default"])(challengeRoot, 'userChallenge');
});
var getUserChallengeDataSelector = (0, _reselect.createSelector)(getUserChallengeSelector, function (userChallenge) {
  return (0, _get["default"])(userChallenge, 'data');
});
exports.getUserChallengeDataSelector = getUserChallengeDataSelector;
var getUserChallengeIsLoadingSelector = (0, _reselect.createSelector)(getUserChallengeSelector, function (userChallenge) {
  return (0, _get["default"])(userChallenge, 'isLoading');
});
exports.getUserChallengeIsLoadingSelector = getUserChallengeIsLoadingSelector;
var getUserChallengeErrorSelector = (0, _reselect.createSelector)(getUserChallengeSelector, function (userChallenge) {
  return (0, _get["default"])(userChallenge, 'error');
});
exports.getUserChallengeErrorSelector = getUserChallengeErrorSelector;
var getUserChallengeHasUpdatedSelector = (0, _reselect.createSelector)(getUserChallengeSelector, function (userChallenge) {
  return (0, _get["default"])(userChallenge, 'hasUpdatedUserChallenge');
});
exports.getUserChallengeHasUpdatedSelector = getUserChallengeHasUpdatedSelector;
var isSuccessChallengeSelector = (0, _reselect.createSelector)(getUserChallengeDataSelector, function (userChallenge) {
  return userChallenge ? (0, _get["default"])(userChallenge, 'status') === 'SUCCESS' : false;
});
exports.isSuccessChallengeSelector = isSuccessChallengeSelector;
var getUserGroupChallengeSelector = (0, _reselect.createSelector)(challengeRootSelector, function (challengeRoot) {
  return (0, _get["default"])(challengeRoot, 'userGroupChallenge');
});
var getUserGroupChallengeDataSelector = (0, _reselect.createSelector)(getUserGroupChallengeSelector, function (userChallenge) {
  return (0, _get["default"])(userChallenge, 'data');
});
exports.getUserGroupChallengeDataSelector = getUserGroupChallengeDataSelector;
var getUserGroupChallengeIsLoadingSelector = (0, _reselect.createSelector)(getUserGroupChallengeSelector, function (userChallenge) {
  return (0, _get["default"])(userChallenge, 'isLoading');
});
exports.getUserGroupChallengeIsLoadingSelector = getUserGroupChallengeIsLoadingSelector;
var getUserChallengeActivities = (0, _reselect.createSelector)(challengeRootSelector, function (challengeRoot) {
  return (0, _get["default"])(challengeRoot, 'userChallengeActivities');
});
var getUserChallengeActivitiesDataSelector = (0, _reselect.createSelector)(getUserChallengeActivities, function (userChallengeActivities) {
  return (0, _get["default"])(userChallengeActivities, 'data');
});
exports.getUserChallengeActivitiesDataSelector = getUserChallengeActivitiesDataSelector;
var getUserChallengeActivitiesLoadingSelector = (0, _reselect.createSelector)(getUserChallengeActivities, function (userChallengeActivities) {
  return (0, _get["default"])(userChallengeActivities, 'isLoading');
});
exports.getUserChallengeActivitiesLoadingSelector = getUserChallengeActivitiesLoadingSelector;
var getUserChallengeActions = (0, _reselect.createSelector)(challengeRootSelector, function (challengeRoot) {
  return (0, _get["default"])(challengeRoot, 'userChallengeActions');
});
var getUserChallengeActionsDataSelector = (0, _reselect.createSelector)(getUserChallengeActions, function (userChallengeActions) {
  return (0, _get["default"])(userChallengeActions, 'data');
});
exports.getUserChallengeActionsDataSelector = getUserChallengeActionsDataSelector;
var getUserChallengeActionsLoadingSelector = (0, _reselect.createSelector)(getUserChallengeActions, function (userChallengeActions) {
  return (0, _get["default"])(userChallengeActions, 'isLoading');
});
exports.getUserChallengeActionsLoadingSelector = getUserChallengeActionsLoadingSelector;
var getChallengeStatsSelector = (0, _reselect.createSelector)([challengeRootSelector], function (challengeRoot) {
  return (0, _get["default"])(challengeRoot, 'challengeStats');
});
var getChallengeStatsDataSelector = (0, _reselect.createSelector)([getChallengeStatsSelector], function (stats) {
  return (0, _get["default"])(stats, 'data');
});
exports.getChallengeStatsDataSelector = getChallengeStatsDataSelector;
var getChallengeStatsIsLoadingSelector = (0, _reselect.createSelector)([getChallengeStatsSelector], function (stats) {
  return (0, _get["default"])(stats, 'isLoading');
});
exports.getChallengeStatsIsLoadingSelector = getChallengeStatsIsLoadingSelector;
var getRegistration = (0, _reselect.createSelector)(challengeRootSelector, function (challengeRoot) {
  return (0, _get["default"])(challengeRoot, 'registration');
});
var getUserRegistrationSuccessSelector = (0, _reselect.createSelector)(getRegistration, function (registration) {
  return (0, _get["default"])(registration, 'success');
});
exports.getUserRegistrationSuccessSelector = getUserRegistrationSuccessSelector;
var getUserRegistrationErrorSelector = (0, _reselect.createSelector)(getRegistration, function (registration) {
  return (0, _get["default"])(registration, 'error');
});
exports.getUserRegistrationErrorSelector = getUserRegistrationErrorSelector;
var getUserRegistrationLoadingSelector = (0, _reselect.createSelector)(getRegistration, function (registration) {
  return (0, _get["default"])(registration, 'isLoading');
});
exports.getUserRegistrationLoadingSelector = getUserRegistrationLoadingSelector;
var getUserGroupChallengeStats = (0, _reselect.createSelector)(challengeRootSelector, function (challengeRoot) {
  return (0, _get["default"])(challengeRoot, 'userGroupChallengeStats');
});
var getUserGroupChallengeStatsDataSelector = (0, _reselect.createSelector)(getUserGroupChallengeStats, function (getUserGroupChallengeStats) {
  return (0, _get["default"])(getUserGroupChallengeStats, 'data');
});
exports.getUserGroupChallengeStatsDataSelector = getUserGroupChallengeStatsDataSelector;
var getUserGroupChallengeStatsIsLoadingSelector = (0, _reselect.createSelector)(getUserGroupChallengeStats, function (getUserGroupChallengeStats) {
  return (0, _get["default"])(getUserGroupChallengeStats, 'isLoading');
});
exports.getUserGroupChallengeStatsIsLoadingSelector = getUserGroupChallengeStatsIsLoadingSelector;
var _default = {
  getChallengeDataSelector: getChallengeDataSelector,
  getChallengeTypeSelector: getChallengeTypeSelector,
  getChallengeIsLoadingSelector: getChallengeIsLoadingSelector,
  getChallengeErrorSelector: getChallengeErrorSelector,
  getChallengeDataDisplaySelector: getChallengeDataDisplaySelector,
  getChallengeGroupChallengeDataSelector: getChallengeGroupChallengeDataSelector,
  getChallengeStatsDataSelector: getChallengeStatsDataSelector,
  getChallengeStatsIsLoadingSelector: getChallengeStatsIsLoadingSelector,
  getUserChallengeDataSelector: getUserChallengeDataSelector,
  getUserChallengeErrorSelector: getUserChallengeErrorSelector,
  getUserChallengeIsLoadingSelector: getUserChallengeIsLoadingSelector,
  getUserChallengeHasUpdatedSelector: getUserChallengeHasUpdatedSelector,
  isSuccessChallengeSelector: isSuccessChallengeSelector,
  getUserChallengeActivitiesDataSelector: getUserChallengeActivitiesDataSelector,
  getUserChallengeActivitiesLoadingSelector: getUserChallengeActivitiesLoadingSelector,
  getUserChallengeActionsDataSelector: getUserChallengeActionsDataSelector,
  getUserChallengeActionsLoadingSelector: getUserChallengeActionsLoadingSelector,
  getUserGroupChallengeDataSelector: getUserGroupChallengeDataSelector,
  getUserGroupChallengeIsLoadingSelector: getUserGroupChallengeIsLoadingSelector,
  getUserRegistrationSuccessSelector: getUserRegistrationSuccessSelector,
  getUserRegistrationErrorSelector: getUserRegistrationErrorSelector,
  getUserRegistrationLoadingSelector: getUserRegistrationLoadingSelector,
  getUserGroupChallengeStatsDataSelector: getUserGroupChallengeStatsDataSelector,
  getUserGroupChallengeStatsIsLoadingSelector: getUserGroupChallengeStatsIsLoadingSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map